/**
 * AKDK frontend entry.
 *
 * Bu dosya Vite tarafından `public/build/assets/app.js` olarak bundle edilir
 * ve Sage'in `bundle('app')->enqueue()` çağrısıyla WordPress'e yüklenir.
 *
 * İçerik:
 *  - Alpine.js (mobile nav, accordion, küçük UI etkileşimleri)
 *  - Lenis smooth scroll (reduce-motion saygılı)
 *  - Three.js hero map dynamic import (sadece anasayfada)
 */

import.meta.glob([
  '../images/**',
  '../fonts/**',
  '../svg/**',
]);

import Alpine from 'alpinejs';
import { initSmoothScroll } from './lenis-scroll.js';

window.Alpine = Alpine;
Alpine.start();

initSmoothScroll();

// Hero WebGL — sadece anasayfada (front-page.blade.php) mount edilir.
const heroMount = document.getElementById('hero-network-map');
if (heroMount) {
  import('./three/hero-network-map.js')
    .then(({ mountHeroNetworkMap }) => mountHeroNetworkMap(heroMount))
    .catch((err) => console.warn('[AKDK] Hero WebGL yüklenemedi:', err));
}
